import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	filledIcon: {
		fill: themeColors.colors.success[600],
		width: "1.125rem",
		height: "1.125rem",
		display: "block"
	},
	alertIcon: {
		fill: themeColors.colors.warning[500],
		width: "1.125rem",
		height: "1.125rem",
		display: "block"
	}
}))

export default useStyles
